export default "__VITE_ASSET__CA58PczW__"